/* eslint-disable object-property-newline */
import React from 'react';
import { Config } from '@leverege/plugin';
import { GlobalState, UI } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import { GroupDelegate } from '@leverege/molten-core';
import { LinkAction } from "../../routes/index.js";
import RelationshipBreadcrumbs from "../view/RelationshipBreadcrumbs.js";
const {
  t
} = I18N.ns('molten.imagine.simpleSearch.SimpleSearchRouteCreator');
function processRelationship(molten, relationship, options) {
  const {
    attribute,
    parentRelationship: pRel,
    blueprint,
    path
  } = relationship;
  if (!relationship.isGroup || attribute == null && !blueprint.hasTag('is:root')) {
    return;
  }
  let grpClient, matches, rel;
  if (attribute != null) {
    grpClient = Config.get('BlueprintRoutes', `${attribute.blueprint.type}.ItemScreen/client`, 'ItemScreen');
    matches = {
      client: grpClient,
      path: pRel.path,
      objectType: attribute.blueprint.type
    };
    rel = attribute;
  } else {
    grpClient = options.rootClient;
    matches = {
      client: grpClient
    };
    rel = blueprint;
  }
  if (!rel?.hasTag('has:simpleSearch')) {
    return;
  }
  const simpleId = `blueprint.${path}.SimpleSearchScreen`;
  const simplePath = `${relationship.urlPath}SimpleSearch`;
  const title = rel.getTagStartingWith('simpleSearchScreenTitle:', true) || t('search', {
    item: rel?.namePlural || rel?.name
  });
  const icon = rel.getIcon('simpleSearchScreenIcon');
  const doodle = rel.getIcon('simpleSearchDoodle');
  const hintIcon = rel.getIcon('simpleSearchHintIcon');
  const hint = rel.getString('simpleSearchHint');
  molten.addPlugin('Route', {
    id: `${simpleId}:breadcrumbs`,
    matches: {
      client: 'Breadcrumbs'
    },
    exact: true,
    path: simplePath,
    render: ({
      match,
      ...rest
    }) => {
      const rel = relationship.createResolved(match);
      const name = t('searchBreadcrumb', {
        item: rel?.namePlural || rel?.name
      });
      return /*#__PURE__*/React.createElement(RelationshipBreadcrumbs, {
        match,
        ...rest,
        relationship: rel.parent,
        extraCrumbs: [{
          name,
          tooltip: name,
          url: rel.url,
          relationship: rel
        }]
      });
    }
  });
  molten.addPlugin('Route', {
    id: simpleId,
    matches,
    exact: true,
    path: simplePath,
    default: isPreferredRoute(attribute),
    render: ({
      match,
      ...rest
    }) => {
      const rRel = relationship.createResolved(match);
      const delegate = new GroupDelegate({
        match,
        relationship: rRel
      });
      const props = {
        match,
        ...rest,
        relationship: rRel,
        delegate,
        actions: delegate,
        // TODO: Remove in future version
        title,
        icon,
        doodle,
        hint,
        hintIcon
      };
      return /*#__PURE__*/React.createElement(Config.get('BlueprintRoutes', `${simpleId}/component`, options.simpleSearchScreen), props);
    }
  });
  const linkActionId = `blueprint.link.${path}.SimpleSearchScreen`;
  const linkSort = rel.getTagStartingWith('simpleSearchNavSort:', true);
  const linkActionName = rel.getTagStartingWith('simpleSearchLinkName:', true) || t('search', {
    item: rel?.namePlural || rel?.name
  });
  const excludeFrom = rel.getTagsStartingWith('excludeSimpleSearchFrom:', true) || [];
  molten.addPlugin('Action', LinkAction.create({
    id: linkActionId,
    layout: Config.get(linkActionId, 'layout', {
      sort: linkSort || `rel.${linkActionName}`
    }),
    matches: {
      use: 'navBar',
      ...matches
    },
    handles: () => {
      const aPersona = UI.get(GlobalState.get()).activePersona?.name;
      return !shouldExclude(aPersona, excludeFrom);
    },
    name: linkActionName,
    icon: getNavIcon(blueprint, attribute),
    path: simplePath
  }));
}
function isPreferredRoute(attr) {
  return !!attr?.hasTag('simpleSearch:preferredView');
}
function shouldExclude(persona, excludeFrom) {
  return excludeFrom.includes(persona) || excludeFrom.includes('*');
}
function getNavIcon(blueprint, attribute) {
  if (attribute == null) {
    return blueprint.getIcon('simpleSearchNavIcon') || blueprint.getIcon('navIcon');
  }
  return attribute.getIcon('simpleSearchNavIcon') || attribute.getIcon('navIcon') || blueprint.getIcon('simpleSearchNavIcon') || blueprint.getIcon('navIcon');
}
export default {
  id: 'molten.BlueprintRouteCreator.SimpleSearch',
  type: 'molten.BlueprintRouteCreator',
  processRelationship
};